import React, { useEffect, useState } from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Box, Button, Grid, Paper, Typography, Card, CardContent, TextField, Grid2, IconButton, Slider, CircularProgress } from '@mui/material';
import { useDrag, useDrop } from 'react-dnd';
import { CREATE_CUSTOM_THERAPY } from '../../utils/constants';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import TherapyReadyImg from '../../assets/images/soundimg/TherapyReadyImg.svg'
import pause from "../../assets/images/pause button.svg";
import play from "../../assets/images/play.svg";
import speaker from "../../assets/images/speaker.svg";
import { titleCase } from '../../utils/main';
import { CenteredBox } from '../../components/layouts/OneViewBox';

const TherapyReadyUi = ({ submit,BackButton, Soundloading,setIsPlaying, location, handlePlayStopAudio, isPlaying, volume, handleVolumeChange }) => {

    const navigate = useNavigate();
    const params = useParams();
    console.log("first",isPlaying)
    return (
        <>
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }} >
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <IconButton
                        sx={{ marginRight: "10px" }}
                        onClick={() => {BackButton()}}
                    >
                        <ArrowBackIosNewIcon sx={{ color: "#424242" }} />
                        <Typography ml={2} className='AxiformaRegular' sx={{ fontSize: "24px", alignItems: "center", color: "#424242" }}>Back</Typography>

                    </IconButton>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", width: "100%" }}>
                    <Typography className='AxiformaMedium' variant="h6" ml={2} sx={{ fontSize: "24px", alignItems: "center", letterSpacing: "0.8em" }}>CUSTOM THERAPY</Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '78vh',
                    border: '1px solid #DEDEDE',
                    backgroundColor: 'white',
                    borderRadius: '10px',
                    backgroundImage: `url(${TherapyReadyImg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    justifyContent: "space-evenly"
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        backdropFilter: 'blur(5px)',
                    }}
                >
                    <Typography
                        className="AxiformaSemiBold"
                        variant="h6"
                        ml={2}
                        sx={{ fontSize: '22px', alignItems: 'center', color: 'black' }}
                    >
                        Your therapy is ready
                    </Typography>
                </Box>
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",

                }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minWidth: "12vw",
                            height: "15vh",
                            border: "1px solid #666666",
                            backgroundColor: "#F5F5F5"
                        }}
                    >
                        <Typography
                            className="AxiformaRegular"
                            variant="h6"
                            ml={2}
                            sx={{ fontSize: '32px', alignItems: 'center', color: '#D34646', pr:3 }}
                        >
                            {titleCase(location?.state?.inputdata[0])}
                        </Typography>

                    </Box>

                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        backdropFilter: 'blur(5px)',
                    }}
                >
                    <Typography
                        className="AxiformaSemiBold"
                        variant="h6"
                        ml={2}
                        sx={{ fontSize: '18px', alignItems: 'center', color: 'black' }}
                    >
                        {titleCase(location?.state?.inputdata)}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        backdropFilter: 'blur(5px)',

                    }}
                >
                    <IconButton onClick={handlePlayStopAudio}>
                        <img
                            src={isPlaying ? pause : play}
                            alt={isPlaying ? 'Pause' : 'Play'}
                            style={{ height: '70px' }}
                        />
                    </IconButton>
                </Box>

                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",

                }}>
                    <Box
                        sx={{
                            display: "flex",
                            // justifyContent: "",
                            alignItems: "center",
                            width: "50%",
                            height: "8vh",
                            border: "1px solid #DEDEDE",
                            backgroundColor: "#FFFFFF"
                        }}
                    >
                        <Box sx={{ width: "5vw", display: "flex", justifyContent: "center" }}>
                            <img src={speaker} style={{ height: "30px" }} />
                        </Box>
                        <Box sx={{ width: "86%", display: "flex", justifyContent: "center" }}>
                            <Slider
                                value={volume}
                                onChange={(e, newValue) => handleVolumeChange(newValue)}
                                min={0}
                                max={100}
                                sx={{
                                    width: '20.703125vw',
                                    zIndex: 3,
                                    position: 'relative',
                                    height: '6px',
                                    '& .MuiSlider-valueLabel': {
                                        backgroundColor: 'white',
                                        color: 'black',
                                        boxShadow:
                                            '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
                                        zIndex: 10,
                                    },
                                }}
                                valueLabelDisplay="auto"
                            />
                        </Box>
                    </Box>

                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        backdropFilter: 'blur(5px)',
                    }}
                >
                    <Button disabled={Soundloading} onClick={() => submit()} className='AxiformaRegular' variant="contained" sx={{ height: "6vh", borderRadius: "10px", ml: 1, width: "25vw", alignItems: "center", justifyContent: "center", backgroundColor: '#424242', color: "#FFFFFF" }}>
                        <Typography className='AxiformaBold' sx={{ fontSize: "24px", alignItems: "center" }}>
                       { Soundloading ?<CenteredBox>
                                <CircularProgress />
                            </CenteredBox>  : "Confirm"}
                        </Typography>
                    </Button>
                </Box>
            </Box>
        </>
    );
};

export default TherapyReadyUi;


